import ActionType from './actionType';



export function CurrentQuizDispatch(payload) {
    return {
        type: ActionType.CurrentQuiz,
        payload
    }
}
export function AllQuestionDisptach(payload) {
    return {
        type: ActionType.QuizDetails,
        payload
    }
}
export function NumberOFQuestions(payload) {
    return {
        type: ActionType.length,
        payload
    }
}

export function FavoriteQuizDispatch(payload) {
    return {
        type: ActionType.Favorite,
        payload
    }
}
export function FavoriteQuizState(){
    return {
        type: ActionType.FavoriteFlag,
    }
}
export function FavoriteErrorDispatch(payload) {
    return {
        type: ActionType.FavoriteError,
        payload
    }
}
export function FavoriteErrorState(){
    return {
        type: ActionType.FavoriteErrorFlag,
    }
}

export function FavorQuizesData(payload){
    return{
        type: ActionType.FavoriteData,
        payload
    }
}


// WEBPACK FOOTER //
// ./src/reducers/container/deatilDispatch.jsx